import { SvgIcon, SvgIconProps } from "@mui/material";

export const VerificationIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "16", height: "17", fill: "none" }}
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M7.91667 0.00251055C5.71808 -0.0174772 3.52003 0.0818966 1.33227 0.300191C0.976969 0.315804 0.64109 0.466302 0.393409 0.720871C0.145728 0.975441 0.0049863 1.31482 0 1.66952C0.00477519 4.00333 -0.0495469 9.06748 0.762235 10.9351C1.53978 12.3065 2.54072 13.5393 3.72405 14.5829C4.58597 15.3223 6.67213 16.6667 7.91667 16.6667C9.1612 16.6667 11.2474 15.3194 12.1099 14.5829C13.2933 13.5393 14.2942 12.3066 15.0717 10.9351C15.8817 9.07224 15.773 4.02893 15.8333 1.68738C15.8258 1.33166 15.6827 0.992158 15.4333 0.737823C15.1838 0.483488 14.8467 0.333401 14.4903 0.318051C12.3059 0.100843 10.1118 -0.00447508 7.91667 0.00251055Z"
        fill="#008B07"
      />
      <path
        d="M4.75 7.40734L7.21296 10.0528L12.1389 4.76184"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
